// Supported tools to be used in Copilot V2 actions
export const ASK_HUBSPOT = 'ask_hubspot';
export const HUBSPOT_HOW_TO = 'hubspot_how_to';
export const COMPANY_NEWS = 'company_news';
export const COMPANY_TECH_STACK = 'company_tech_stack';
export const CONTENT_REWRITE = 'content_rewrite';
export const OBJECT_SUMMARY = 'object_summary';
export const CRM_OBJECT_SEARCH = 'crm_object_search';
export const CRM_OBJECT_SEARCH_V2 = 'crm_object_search_v2';
export const CRM_BASIC_SEARCH = 'crm_basic_search';
export const CRM_OBJECT_LIST = 'crm_object_list';
export const CRM_OBJECT_SUMMARY = 'crm_object_summary';
export const CRM_OBJECT_UPSERT = 'crm_object_upsert';
export const CRM_META_SEARCH = 'crm_meta_search';
export const FEEDBACK_SUBMISSION_SUMMARY = 'feedback_submission_summary';
export const INVOICES_CREATE = 'invoices_create';
export const REPORTING_INSIGHTS_COPILOT_GENERATION = 'reporting_insights_copilot_generation';
export const TEXT_GENERATION = 'text_generate';
export const WORKFLOW_CREATE = 'workflow_create';
export const WORKFLOW_GENERATION = 'workflow_generation';
export const INTERACTIVE_TOOL = 'interactive_tool';
export const INTERACTIVE_TOOL_BUTTON_CLICK = 'interactive_tool_button_click';
export const REPORT_BUILDER = 'report_builder';
export const WEB_SEARCH = 'web_search';
export const THINK = 'think';
export const PRICING_PACKAGING = 'pricing_packaging';
export const DASHWORKS_SEARCH = 'dashworks_search';
export const CHANGE_FOCUS = 'load_tools';